import React from 'react'
import { Box } from '@rebass/grid'

const Column = (props) => <Box {...props} />

Column.defaultProps = {
   px: ['16px', '12px'],
   width: [1],
}

export default Column
